export default "__VITE_ASSET__Dpsg7ImT__"